import { useNavigate, useRouterState } from "@tanstack/react-router"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useInviteEmployeeMutation } from "modules/settings/hooks/useInviteEmployeeMutation"
import { useTranslation } from "react-i18next"
import { InviteEmployeeSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { InviteEmployeeForm } from "./InviteEmployeeForm"

export function InviteEmployee() {
  const { t } = useTranslation()
  const { mutateAsync, isPending } = useInviteEmployeeMutation()
  const navigate = useNavigate()
  const { location } = useRouterState()

  function onClose() {
    if (location.href.includes("/settings/invites")) {
      navigate({ to: "/settings/team" })
    } else {
      navigate({ to: "/settings/team" })
    }
  }

  const onSubmitSignup = async (data: z.infer<typeof InviteEmployeeSchema>) => {
    const response = await mutateAsync(data)

    if (response) {
      toast.success(t("settings.team.inviteEmployee.success"))
      navigate({ to: "/settings/team" })
    }
  }

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[475px]">
        <DialogHeader>
          <DialogTitle>{t("settings.team.inviteEmployee.title")}</DialogTitle>
          <DialogDescription>{t("settings.team.inviteEmployee.description")}</DialogDescription>
        </DialogHeader>
        <InviteEmployeeForm onSubmit={onSubmitSignup} isPending={isPending} />
      </DialogContent>
    </Dialog>
  )
}
